/* idempotency guard */
if(!window.__cynBooted){window.__cynBooted=1;
/* ===== Cynéhance ™ — comportements partagés ===== */

(function(){

  'use strict';



  /* --- CTA : défile vers le sélecteur de quantité / infos produit --- */

  function scrollTarget(){

    var sel=['.cyn-hero__size','.cyn-bd','.quantity-break','.quantity-selector','pickup-availability',

             '.product-form__buttons','.product-form','.price'];

    for(var i=0;i<sel.length;i++){var el=document.querySelector(sel[i]);if(el)return el;}

    return null;

  }

  function headerOffset(){

    var h=document.querySelector('.section-header, .header-wrapper, sticky-header, header');

    var hh=h?h.getBoundingClientRect().height:0;

    if(!hh||hh>200)hh=90; /* header collant surdimensionné → clamp */

    return hh+12;

  }

  document.addEventListener('click',function(e){

    var t=e.target.closest('[data-cyn-scroll]');

    if(!t)return;

    e.preventDefault();

    var el=scrollTarget();

    if(!el)return;

    var y=el.getBoundingClientRect().top+window.pageYOffset-headerOffset();

    window.scrollTo({top:y,behavior:'smooth'});

  });



  /* --- Carrousels génériques (flèches + points) --- */

  function initCaro(root){

    var track=root.querySelector('[data-cyn-track]');

    if(!track)return;

    var prev=root.querySelector('[data-cyn-prev]');

    var next=root.querySelector('[data-cyn-next]');

    var dots=root.querySelectorAll('[data-cyn-dot]');

    function step(){

      var card=track.firstElementChild;

      if(!card)return track.clientWidth*0.8;

      var gap=parseInt(getComputedStyle(track).columnGap||getComputedStyle(track).gap||16)||16;

      return card.getBoundingClientRect().width+gap;

    }

    if(next)next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});

    if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});

    function active(){

      if(!dots.length)return;

      var idx=Math.round(track.scrollLeft/step());

      dots.forEach(function(d,i){d.classList.toggle('is-active',i===idx);});

    }

    track.addEventListener('scroll',active);

    dots.forEach(function(d,i){d.addEventListener('click',function(){track.scrollTo({left:step()*i,behavior:'smooth'});});});

    active();

  }

  function initAll(){document.querySelectorAll('[data-cyn-caro]').forEach(initCaro);}



  /* --- Onglets (frise chronologique) --- */

  function initTabs(root){

    var btns=root.querySelectorAll('[data-cyn-tab-btn]');

    var panes=root.querySelectorAll('[data-cyn-tab-pane]');

    btns.forEach(function(b){

      b.addEventListener('click',function(){

        var i=b.getAttribute('data-cyn-tab-btn');

        btns.forEach(function(x){x.classList.toggle('is-active',x===b);});

        panes.forEach(function(p){p.classList.toggle('is-active',p.getAttribute('data-cyn-tab-pane')===i);});

      });

    });

  }

  function initAllTabs(){document.querySelectorAll('[data-cyn-tabs]').forEach(initTabs);}



  /* --- Anneaux de pourcentage (animation à l'apparition) --- */

  function initRings(){

    var rings=document.querySelectorAll('[data-cyn-ring]');

    if(!rings.length)return;

    var io=new IntersectionObserver(function(entries){

      entries.forEach(function(en){

        if(en.isIntersecting){

          var r=en.target;var pct=parseFloat(r.getAttribute('data-cyn-ring'))||0;

          var circle=r.querySelector('circle.cyn-ring-prog');

          if(circle)circle.style.strokeDasharray=pct+' 100';

          io.unobserve(r);

        }

      });

    },{threshold:.3});

    rings.forEach(function(r){io.observe(r);});

  }



  function boot(){initAll();initAllTabs();initRings();}

  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);

  document.addEventListener('shopify:section:load',boot);

})();


}
